import React from 'react';
import styles from '../WildHeartForm.module.scss';

const SectionTextDelimiter = ({ label }) => {
  return <p className={styles.formTextDelimiter}>{label}</p>;
};

export default SectionTextDelimiter;
